// extracted by mini-css-extract-plugin
export default {"mainContainer":"PaymentHistory_mainContainer__7hida","gridContainer":"PaymentHistory_gridContainer__zUAiM"};